import { useMutation, useQueryClient } from '@tanstack/react-query';
import { npsQueryKey } from 'queries/nps/queryKey';
import { NpsCampaignApi } from 'api/ApiHelper';
import { NpsCampaignAnswerRequestDto } from '@diritto/common/dataAnalysis/dtos/nps-campaign.request.dto';

export const useAnswerNpsCampaignMutation = (npsCampaignId?: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: npsQueryKey.npsCampaignAnswer(npsCampaignId),
    mutationFn: (npsAnswerRequestDto: NpsCampaignAnswerRequestDto) => {
      // 시점 차이로 인해 isAnswered 체크가 제대로 안될 수 있다. 메모리에 마크 하자.
      queryClient.setQueryData(npsQueryKey.npsCampaignAnswer(npsCampaignId), { isAnswered: true });
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      return NpsCampaignApi.answerNpsCampaign(npsCampaignId!, npsAnswerRequestDto);
    },
  });
};
